import { SET_AUTHENTICATION_TOKEN_PARAM_PRESENT, SET_DEPOSIT_AMOUNT, SET_DEPOSIT_CONFIRMED, SET_DEPOSIT_CREDIT_CARD, SET_DEPOSIT_PAYMENT_METHOD } from "../actions/deposit";
import buildReducer from "./build-reducer";
import { Map } from "immutable";

let reducers = {};

reducers[SET_AUTHENTICATION_TOKEN_PARAM_PRESENT] = (state, { value }) =>
  state.set("authenticationTokenParamPresent", value);

reducers[SET_DEPOSIT_AMOUNT] = (state, { amount: amount }) =>
  state.set("amount", amount).remove("confirmed");

reducers[SET_DEPOSIT_CONFIRMED] = (state) =>
  state.set("confirmed", true).merge(defaultDeposit);

reducers[SET_DEPOSIT_CREDIT_CARD] = (state, { field, value}) =>
  state.set(field, value);

reducers[SET_DEPOSIT_PAYMENT_METHOD] = (state, { paymentMethod: paymentMethod }) =>
  state.set("paymentMethod", paymentMethod);

const defaultDeposit = Map({
  firstName: "",
  lastName: "",
  cardNumber: "",
  expMonth: "",
  expYear: "",
  cvv: "",
  rememberCard: true
});

export default buildReducer(defaultDeposit, reducers);
